import React from 'react';

// rn-range-slider breaks storybook
// if storybook doesn't work percy can't run and we can't merge into tech
const Slider = () => {
  return null;
};

export default Slider;
